import(/* webpackMode: "eager" */ "/src/clients/web/src/app/error.tsx");
